import { api } from './http.js'

/**
 * A case just saved at a company that has another open case (D-257, D-226): whoever saved it is
 * told in the app — through whom the other one runs and who has it. Read from the case context;
 * offline or on failure nothing is said.
 */
export async function channelWarning(uuid, ui, t) {
  try {
    const context = (await api(`/opportunities/${uuid}/context`, { timeoutMs: 8000 })).data
    const companies = context?.companies || []
    const target = companies.find((c) => c.role === 'end_customer') || companies.find((c) => c.role === 'buyer')
    const open = (target?.other_cases || []).filter((o) => o.status === 'open')
    if (!open.length) return null
    const first = open[0]
    const text = t('channels.conflictWarning', {
      company: target.account?.label || '',
      case: first.label,
      via: first.via?.label ? t('channels.conflictVia', { partner: first.via.label }) : '',
      more: open.length > 1 ? t('channels.conflictMore', { n: open.length - 1 }) : '',
    })
    ui.warn(text)
    return text
  } catch {
    return null
  }
}
